<template>
    <div class="container">
        <addBankAccountDetails
            v-if="showAddBankDetails"
            @closeAddBankDetails = "closeAddBankDetails"
            :onBoardingComponent="onBoardingComponent"
        />
        <Waiting
            v-if="isWaiting"
            :message="waitingMessage"
        />
        <FailureDialog
            v-if="isFailure"
            :message="failureMessage"
            @handleClose="handleCloseFailure"
        />
        <link rel="preconnect" href="https://fonts.googleapis.com">
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
        <link href="https://fonts.googleapis.com/css2?family=Inter&display=swap" rel="stylesheet">
        <div class="container-local" v-if="!showAddBankDetails && !isWaiting">
            <div class="div-heading">
                <button class = "back_image">
                    <img src = "/img/arrow_back.svg" @click="goBack"/>
                </button>
                <span class="heading-mobile-top">
                    Bank Account Details
                </span>
            </div>
            <div class="main-content">
                <div class="bank-add">
                    <span class="heading">
                        Bank & Account Details
                    </span>
                    <span class="heading-mobile">
                        Banks
                    </span>
                    <button class="addButton" @click="openBankDetails">
                        Add Another Bank
                    </button>
                </div>
                <div v-for="bank in banks" :key="bank.number">
                    <div class="bank-details" v-if="!bank.isDeleted">
                        <div class="bank">
                            <div class="bank-logo">
                                <img src = "/img/Bank-Blue.jpg"/>
                            </div>
                        </div>
                        <div class="data-bank">
                            <v-menu offset-y>
                                <template v-slot:activator="{ on }" v-if="!bank.isPrimary">
                                    <div class="dots primary-bank" v-on="on" >
                                        <img src = "/img/Dots.png"/>
                                    </div>
                                </template>
                                <v-list v-if="bank.isPrimaryBank">
                                    <v-list-item v-for="(item, index) in optionsPrimary" :key="index" @click="onItemClick(item,bank)" >
                                        <v-list-item-title >{{ item }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                                <v-list v-else>
                                    <v-list-item v-for="(item, index) in optionsNonPrimary" :key="index" @click="onItemClick(item,bank)" >
                                        <v-list-item-title >{{ item }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                            <p class="bank-name">{{ bank.bankName }}</p>
                            <p class="account-no">{{ bank.accountNumber }}</p>
                            <p class="primary-bank" v-if="bank.isPrimary">Primary Bank</p>
                            <div class="verified-primary">
                                <p class="verified">
                                    <img src = "/img/verified.png"/>
                                    Verified
                                </p>
                                <!-- <p v-if="bank.isPrimaryBank" class="primary-bank">Primary Bank</p>
                                <p v-else class="primary-bank">Make Primary</p> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bank-add-button">
                    <button class="addButtonMobile" @click="openBankDetails">
                        Add Another Bank
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import addBankAccountDetails from '@/components/bankAccountDetails/addBankAccountDetails.vue'
import Waiting from './waiting.vue'
import FailureDialog from './failure.vue'
import LenderService from '@/services/lenderService'

export default {
    name: 'BankAccountDetails',
    components: {
        addBankAccountDetails,
        Waiting,
        FailureDialog
    },
    props: {
        onBoardingComponent: Boolean
    },
    data: () => ({
        optionsNonPrimary: [
            'Delete',
            'Make Primary'
        ],
        optionsPrimary: [
            'Delete'
        ],
        banks: [],
        showOptions: false,
        showAddBankDetails: false,
        isWaiting: false,
        waitingMessage: '',
        isFailure: false,
        failureMessage: ''
    }),
    mounted () {
        this.getBankdata()
    },
    methods: {
        goBack () {
            if (this.onBoardingComponent) {
                this.$emit('goBack')
            } else {
                this.$router.push('/dashboard')
            }
        },
        openBankDetails () {
            this.showAddBankDetails = true
        },
        closeAddBankDetails () {
            if (this.onBoardingComponent) {
                this.$emit('goBack')
            } else {
                this.getBankdata()
                this.showAddBankDetails = false
            }
        },
        async getBankName (ifsc) {
            const response = await LenderService.getIfscCode(ifsc)
            return response.data.BANK
        },
        async getBankdata () {
            this.banks = []
            this.isWaiting = true
            this.waitingMessage = 'Please wait we are fetching your bank details'
            const response = await LenderService.getBankAccounts()
            if (response.status === 200) {
                this.isWaiting = false
                var banks = response.data
                for (var i = 0; i < banks.length; i++) {
                    banks[i].bankName = await this.getBankName(banks[i].ifsc)
                    banks[i].accountNumber = `${banks[i].accountNumber}`.slice(-4).padStart(`${banks[i].accountNumber}`.length, 'X')
                    banks[i].isPrimaryBank = false
                }
                this.banks = banks
            } else {
                this.isWaiting = false
                this.isFailure = true
                this.failureMessage = 'Currently we are facing some technical issue in verifying details.'
            }
            setTimeout(() => {
                this.handleCloseFailure()
            }, 5000)
        },
        async deleteBank (bank) {
            this.isWaiting = true
            this.waitingMessage = 'Please wait we are processing your request'
            const payload = {
                bankAccountId: bank._id
            }
            const response = await LenderService.deleteBankAccount(payload)
            if (response.status === 200) {
                this.isWaiting = false
                this.getBankdata()
                if (this.onBoardingComponent) {
                    this.$emit('goBack')
                }
            } else {
                this.isWaiting = false
                this.isFailure = true
                this.failureMessage = 'Currently we are facing some technical issue in deleting your bank account.'
            }
            setTimeout(() => {
                this.handleCloseFailure()
            }, 5000)
        },
        handleCloseFailure () {
            this.isFailure = false
        },
        async changePrimaryBank (bank) {
            this.isWaiting = true
            const payload = {
                bankAccountId: bank._id
            }
            this.waitingMessage = 'Please wait we are processing your request'
            const response = await LenderService.makePrimaryBankAccount(payload)
            if (response.status === 200) {
                this.isWaiting = false
                if (this.onBoardingComponent) {
                    this.$store.dispatch('onBoarding/setField', { field: 'Bank Account Number', value: bank.accountNumber })
                    this.$emit('goBack')
                }
                this.getBankdata()
            } else {
                this.isWaiting = false
                this.isFailure = true
                this.failureMessage = 'Currently we are facing some technical issue in changing your primary bank.'
            }
            setTimeout(() => {
                this.handleCloseFailure()
            }, 5000)
        },
        onItemClick (option, bank) {
            if (option === 'Delete') {
                this.deleteBank(bank)
            } else if (option === 'Make Primary') {
                this.changePrimaryBank(bank)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/components/dashboard/dashboard.scss";

.container-local {
    width: 60% !important;
    align-items: center;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
}
.container {
    height: 100%;
    margin-top:40px;
    justify-content: center !important;
    display: flex;
}
.main-content {
    width: 100%;
    display: block;
    margin-left: 5%;
}
.heading, .heading-mobile {
    font-family: Inter;
    font-size: 22px;
    font-weight: 500;
    line-height: 27px;
    letter-spacing: 0em;
    text-align: left;
}
.heading-mobile {
    font-weight: 700 !important;
}
.heading-mobile-top {
    font-size: 17px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: center;
    width: 100%;
    margin-right: 30px;
    color: #414042;
}
.addButtonMobile {
    width: 80%;
    height: 50px;
    font-weight: 500;
    font-size: 16px !important;
    line-height: 150%;
    display: flex;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
}
.addButton, .addButtonMobile {
    font-family: 'Inter', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 150%;
    display: inline-flex;
    align-items: right !important;
    text-align: center;
    float: right;
    letter-spacing: 0.005em;

    color: #002FA7;
    border: solid #002FA7 2px;
    padding: 7px 14px;
    border-radius: 8px;

}
.bank-details{
    margin-top: 0px;
    margin-bottom: 15px;
    background-color: #F1F7FF;
    height:150px;
    display: flex;
    height: auto;
    padding: 20px;
    width:100%;
}
.bank-logo {
    background-color:#FFFFFF;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    display: flex;
    align-items:center;
    justify-content:center;
}
.dots {
    width: 24px;
    height: 24px;
    display: flex;
    align-items:center;
    justify-content:center;
    margin-top: 1px;
    margin-right: 2px;
    position:absolute;
    top:0;
    right:0;
    cursor: pointer;
}
.bank-name {
    font-weight: 600;
    font-size: 21px;
    line-height: 100%;
    margin-bottom: 2px;
}
.verified-primary {
    margin-top: 12px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    flex-wrap: wrap;
}
.account-no {
    font-size: 17px;
    color: rgba(31, 31, 31, 0.5);;
}
.primary-bank {
    color: #007AFF;
    font-size: 13px;
    line-height: 16px;
    font-weight: 600;
}
.bank {
    width:60px;
    justify-content: center;
    display: flex;
    align-items: center;
}
p {
    margin:0px;
}
.data-bank {
    justify-content: center;
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
}
.verified {
    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 13px;
    letter-spacing: 0.005em;
    text-align: left;
    color: #1F1F1F80;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    img {
        padding-right:5px;
    }
}
.bank-add {
    margin-bottom: 62px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.back_image {
    margin-top: 6px;
}

@media (max-width: 480px) {
    .container-local {
        width: -webkit-fill-available !important;
        flex-direction: column;
        justify-content: flex-start;
    }
    .container {
        margin-top:10px;
        padding: 0px !important;
    }
    .main-content {
        margin: 15px !important;
        margin-top: 0px !important;
        width: -webkit-fill-available;
    }
    .addButton {
        display: none;
    }
    .bank-add {
        margin-bottom: 18px !important;
        margin-right: 20px !important;
    }
    .bank-add-button {
        margin-top: 100px;
        display: flex;
        justify-content: center;
    }
    .addButtonMobile {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .heading-mobile {
        margin-top: 28px;
    }
    .heading {
        display: none;
    }
    .back_image {
        margin-left: 10px;
    }
    .div-heading {
        display: flex;
        align-items: center;
        width: 100%;
    }
    .bank-name {
        font-size: 15px;
    }
    .account-no {
        font-size: 13px;
    }
}

@media (min-width: 481px) and (max-width: 768px){
    .container-local {
        width: 90% !important;
    }
    .bank-add-button {
        display: none;
    }
    .heading-mobile, .heading-mobile-top {
    display: none;
}
}

@media (min-width: 768px){
    .bank-add-button {
        display: none;
    }
    .heading-mobile, .heading-mobile-top {
        display: none;
    }
}

</style>
